// extracted by mini-css-extract-plugin
module.exports = {"root":"G_ty2UKZ","label":"Hr1Ixi1r","labelReversed":"_XXjSpTc"};